import React from 'react'
//TODO needed?
import '../../App.css'

export default function Services(){
    return (
        <h1 className='services'>SERVICES</h1>
    )
}